var Alberta = "Alberta";
var Manitoba = "Manitoba";
var Nunavut = "Nunavut";
var Ontario = "Ontário";
var Quebec = "Quebec";
var Saskatchewan = "Saskatchewan";
var Yukon = "Yukon";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Colúmbia Britânica",
	Manitoba: Manitoba,
	"New Brunswick": "Nova Brunswick",
	"Newfoundland and Labrador": "Terra Nova e Labrador",
	"Northwest Territories": "Territórios do Noroeste",
	"Nova Scotia": "Nova Escócia",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Ilha do Príncipe Eduardo",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
